document.addEventListener("DOMContentLoaded", function () {
    const words = document.querySelectorAll(".list_animation .hide p");
    let current = 0;
    function showNextWord() {
        words.forEach(word => word.classList.remove("active"));
        words[current].classList.add("active");
        current = (current + 1) % words.length;
    }
    showNextWord();
    setInterval(showNextWord, 2000);
});